var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTesti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9487 31H6.9239C6.68999 31 6.5062 30.8167 6.5062 30.5833V8.91667C6.5062 8.68333 6.68999 8.5 6.9239 8.5H28.6443C28.8782 8.5 29.062 8.68333 29.062 8.91667C29.062 9.6 29.6301 10.1667 30.3151 10.1667C31.0001 10.1667 31.5682 9.6 31.5682 8.91667C31.5682 7.31667 30.2483 6 28.6443 6H6.9239C5.31993 6 4 7.31667 4 8.91667V30.5833C4 32.1833 5.31993 33.5 6.9239 33.5H16.9487C17.6337 33.5 18.2018 32.9333 18.2018 32.25C18.2018 31.5667 17.6337 31 16.9487 31Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5405 15.886C34.6699 14.0155 31.6107 14.0155 29.7401 15.886L28.4989 17.1272L22.8349 22.7913C22.258 23.3682 21.9434 24.1373 21.9434 24.959V29.172C21.9434 29.8888 22.5377 30.4832 23.2545 30.4832H27.4675C28.2892 30.4832 29.0584 30.1685 29.6352 29.5916L35.2993 23.9276L36.5405 22.6864C38.411 20.8159 38.411 17.7566 36.5405 15.886ZM34.6874 17.7391C35.544 18.5957 35.544 19.9767 34.6874 20.8333L34.3728 21.148L31.2785 18.0538L31.5932 17.7391C32.4498 16.8825 33.8308 16.8825 34.6874 17.7391ZM27.7822 27.7386C27.7822 27.7386 27.5899 27.8609 27.4675 27.8609H24.5656V24.959C24.5656 24.8366 24.618 24.7317 24.688 24.6443L29.4255 19.9068L32.5197 23.001L27.7822 27.7386Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2658 13C9.58077 13 9.0127 13.5667 9.0127 14.25C9.0127 14.9333 9.58077 15.5 10.2658 15.5H25.303C25.988 15.5 26.5561 14.9333 26.5561 14.25C26.5561 13.5667 25.988 13 25.303 13H10.2658Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6198 18H10.2658C9.58077 18 9.0127 18.5667 9.0127 19.25C9.0127 19.9333 9.58077 20.5 10.2658 20.5H18.6198C19.3048 20.5 19.8729 19.9333 19.8729 19.25C19.8729 18.5667 19.3048 18 18.6198 18Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6198 23H10.2658C9.58077 23 9.0127 23.5667 9.0127 24.25C9.0127 24.9333 9.58077 25.5 10.2658 25.5H13.6198C14.3048 25.5 14.8729 24.9333 14.8729 24.25C14.8729 23.5667 14.3048 23 13.6198 23Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTesti);
export default __webpack_public_path__ + "static/media/testi.62096fbc.svg";
export { ForwardRef as ReactComponent };